import Chatboticon from "./chatboticon";
import TypeWriter from "./TypeWriter";
import { useState } from "react";
import Unavailable from "./Unavilable";

const Message = ({ message, onTypeWriterComplete, isMessageCompleted }) => {
    const isQuery = message.type === "query";
    const isError = message.type === "error";
  
    // Function to convert markdown-style links to JSX
    const parseLinks = (text) => {
      const parts = [];
      const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
      let lastIndex = 0;
      let match;
  
      while ((match = linkRegex.exec(text)) !== null) {
        if (match.index > lastIndex) {
          parts.push(text.slice(lastIndex, match.index));
        }
  
        parts.push(
          <a
            key={match.index}
            href={match[2]}
            target="_blank"
            rel="noopener noreferrer"
            className="text-purple-600 hover:underline font-medium"
            style={{ color: '#6B349A', textDecoration: 'underline' }}
          >
            {match[1]}
          </a>
        );
  
        lastIndex = match.index + match[0].length;
      }
  
      // Add remaining text
      if (lastIndex < text.length) {
        parts.push(text.slice(lastIndex));
      }
  
      return parts;
    };

    // Function to render property cards with booking links
    const renderPropertyCards = (properties) => {
      if (!properties || !Array.isArray(properties)) return null;
      
      return (
        <div className="space-y-3 mt-3">
          {properties.map((property, index) => (
            <div key={index} className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-lg p-4 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-start justify-between mb-2">
                <h4 className="font-semibold text-gray-900 text-base">{property.hotelname}</h4>
                <span className="text-lg font-bold text-purple-600 bg-purple-100 px-2 py-1 rounded">
                  {property.price}
                </span>
              </div>
              <p className="text-sm text-gray-600 mb-3 leading-relaxed">{property.description}</p>
              <div className="flex items-center justify-between">
                <div className="text-xs text-gray-500">
                  💰 Save up to 30% vs Airbnb
                </div>
                <a 
                  href={property.link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-gradient-to-r from-purple-600 to-purple-700 text-white px-4 py-2 rounded-lg text-sm font-medium hover:from-purple-700 hover:to-purple-800 transition-all duration-200 shadow-sm hover:shadow-md"
                >
                  🏠 Book Now
                </a>
              </div>
            </div>
          ))}
        </div>
      );
    };

    const renderContent = (text) => {
      return text.split("\n").map((line, i) => (
        <p key={i} className="text-sm leading-relaxed">
          {parseLinks(line.replaceAll("**", ""))}
        </p>
      ));
    };
  
    return (
      <div className={`flex ${isQuery ? "justify-end" : "justify-start"} mb-4`}>
        {!isQuery && (
          <div className="w-8 h-8 rounded-full flex items-center justify-center mr-2 self-end mb-2">
            <div className="w-6 h-6">
              {message.intent != 'compare' ? <Chatboticon /> : null}
            </div>
          </div>
        )}
        <div
          className={`max-w-[80%] rounded-2xl  text-sm p-4 ${
            isQuery
              ? "text-white bg-purple-500   rounded-br-none"
              : isError
              ? "bg-red-50 border border-red-200 text-red-800 rounded-bl-none"
              : "bg-white shadow-md text-black rounded-bl-none"
          }`}
        >
          {message.intent === "region_unavailable" ? (
            <Unavailable />
          ) : isError ? (
            <div className="flex items-center space-x-2">
              <span className="text-red-500">⚠️</span>
              <span className="text-sm">{message.text}</span>
            </div>
          ) : (
            <>
              {message.intent && (
                <div className="text-sm font-semibold mb-2 text-sm text-gray-800">
                  {message.intent === "compare" && message.results ? (
                    <div className="text-md leading-relaxed">Sure, This is comparison with Airbnb</div>
                  ) : (
                    <span className={`${isQuery ? "text-white" : "text-purple-600"}`} />
                  )}
                </div>
              )}
              {message.intent !== "compare" && (
                <div className="space-y-2">
                  {isQuery ? (
                    message.text.split("\n").map((line, i) => (
                      <p key={i} className="text-sm leading-relaxed">
                        {parseLinks(line.replaceAll("**", ""))}
                      </p>
                    ))
                  ) : (
                    <>
                      <TypeWriter 
                        text={message.text} 
                        speed={20}
                        renderHTML={(text) => renderContent(text)}
                        onComplete={() => onTypeWriterComplete && onTypeWriterComplete(message.id)}
                        isRestarting={false}
                        isMessageCompleted={isMessageCompleted}
                      />
                      {/* Render property cards only after typewriter completes */}
                      {isMessageCompleted && message.properties && renderPropertyCards(message.properties)}
                    </>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  };

  export default Message;